import React, {useCallback, useEffect} from 'react';
import {CF} from 'module/CustomField/util/CustomField';
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {CFValue} from 'module/CustomField/type/CFType';
import {KostSelectComponent} from 'module/Kost/component/KostSelectComponent'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {selKostVisibleIds} from 'module/Kost/selector/KostSelector'
import {useSelector} from 'react-redux'
import {getMemoSelectedSize, isMemoAutoAddActive} from 'module/Memo/util/MemoUtil'
import {KostSelectComponentProps} from 'module/Kost/type/KostSelectType'

export function CustomFieldKostSelectComponent(props: CFComponentProps<CFValue>) {
	const {cfDef, setCb, model, disabled, placeholderHTML, pos} = props
	const value = CF.getValueFrom(cfDef, model, {pos})
	const showOnlyVisible = CF.getCFAttr(cfDef, CFAttrKey.showOnlyVisible)?.value !== 'N'
	const visibleKostkeys = useSelector(selKostVisibleIds)
	const sfv = CF.getCFAttr(cfDef, CFAttrKey.selectFirstVisible)?.value
	const selectFirstVisible = visibleKostkeys.length < 2 && sfv !== 'N' || sfv === 'J'
	const firstVisibleKost = visibleKostkeys[0]
	const menuWidth = Number(CF.getCFAttr(cfDef, CFAttrKey.menuWidth)?.value)
	useEffect(() => {
		if (selectFirstVisible && !value && firstVisibleKost) {
			setCb(firstVisibleKost)
		}
	}, []);
	const onChange: KostSelectComponentProps['onChange'] = useCallback((kost) => {
		setCb(kost?.value || null)
	}, [setCb])
	return (
		<div className={'CustomFieldKostSelectComponent'}>
			<KostSelectComponent
				kostkey={value as string}
				onChange={onChange}
				disabled={disabled}
				placeholderHTML={placeholderHTML}
				showOnlyVisible={showOnlyVisible}
				memoSize={getMemoSelectedSize(cfDef)}
				memoAutoAdd={isMemoAutoAddActive(cfDef)}
				menuWidth={menuWidth}
			/>
		</div>
	)
}